const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function jsonOrThrow(res) {
  let body = null;
  try {
    body = await res.json();
  } catch {
    // Some responses (204, or an HTML error page) legitimately have no JSON body.
  }
  if (!res.ok) {
    const detail = (body && (body.detail || body.message)) || `Request failed (${res.status})`;
    throw new Error(detail);
  }
  return body;
}

export async function getAccountStatus() {
  const res = await fetch(`${API}/account/status`);
  return jsonOrThrow(res);
}

export async function saveCredentials(barcode, pin) {
  const res = await fetch(`${API}/account/credentials`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ barcode, pin }),
  });
  return jsonOrThrow(res);
}

export async function disconnectAccount() {
  const res = await fetch(`${API}/account/credentials`, { method: "DELETE" });
  return jsonOrThrow(res);
}

export async function placeHold(cn, pickupOrg) {
  const res = await fetch(`${API}/library/hold`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cn, pickupOrg }),
  });
  return jsonOrThrow(res);
}

export function cnFromUrl(url) {
  if (!url) return null;
  const m = String(url).match(/cn=(\d+)/);
  return m ? m[1] : null;
}
